import React from "react";
import { Tag } from "@design-system/Tag/Tag";
import { ActiveTransaction } from "./ActiveTransaction";
import { PairedTransactionData } from "./schema";
import styles from "./HistoryPairedTransferDetails.module.scss";

interface PairedTransferTransactionProps {
    transaction: PairedTransactionData;
}

export const PairedTransferTransaction: React.FC<
    PairedTransferTransactionProps
> = ({ transaction }) => {
    const description =
        transaction.displayDescription ?? transaction.bankDescription;

    if (transaction.amount == null) {
        return (
            <div className={styles.deletedTransactionContent}>
                <div className={styles.descriptionColumn}>{description}</div>
                <Tag color="neutral" outline>
                    Deleted
                </Tag>
            </div>
        );
    }

    return (
        <ActiveTransaction
            transaction={
                transaction as PairedTransactionData & { amount: number }
            }
        />
    );
};
